import React, { useState } from 'react';
import { useStore } from 'zustand';
import { useAuthStore } from '../stores/authStore';
import Login from '../components/specific/Login/Login';
import { useNavigate } from 'react-router-dom';
import {useMessageStore} from "../stores/messageStore";
import userAPI from "../api/userAPI";
import {RoleType} from "../types/Role";


const LoginContainer: React.FC = () => {
  const navigate = useNavigate();
  const { login, logout, setRoles } = useStore(useAuthStore);
  const { setMessages } = useStore(useMessageStore);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    try {
      await login(email, password);
      const roles = await userAPI.getRoleAPI();
      setRoles(roles as RoleType[]);

      if (!roles) {
        await logout();
        navigate('/login');
        setMessages('error', 'role is empty');
        return;
      }

      if (roles.includes('business_admin') || roles.includes('business_operator')) {
        navigate('/app/business/cashManage');
        return;
      }

      if (roles.includes('system_admin') || roles.includes('system_operator')) {
        navigate('/app/system/batchRun');
        return;
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Login
      email={email}
      setEmail={setEmail}
      password={password}
      setPassword={setPassword}
      handleLogin={handleLogin}
    />
  );
};

export default LoginContainer;
